var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22973 19.9728C3.93066 19.9728 3.14566 19.1299 3.09009 17.9558C3.09009 15.5661 5.67666 14.7417 9.57391 14.7139C13.4781 14.751 16.0716 15.5753 16.0577 17.9558C15.9952 19.1299 15.2148 19.9728 13.918 19.9728H5.22973Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.38462,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57948 11.9859C11.3892 11.9859 12.8561 10.519 12.8561 8.70931C12.8561 6.89968 11.3892 5.43268 9.57948 5.43268C7.76987 5.43268 6.30286 6.89968 6.30286 8.70931C6.30286 10.519 7.76987 11.9859 9.57948 11.9859Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.38462,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7516 13.6754C18.4885 14.039 19.5312 14.8183 19.523 16.2248C19.4814 17.0062 19.0726 17.6183 18.3758 17.8598",
    stroke: "#CCCCCC",
    strokeWidth: 1.38462,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8287 6.71994C15.8935 6.98599 16.6823 7.949 16.6823 9.09623C16.6823 10.1734 15.9868 11.0882 15.0205 11.4161",
    stroke: "#CCCCCC",
    strokeWidth: 1.38462,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsIcon);
export default __webpack_public_path__ + "static/media/contactsIcon.8460d12f68418e8868f1ddb3025665cf.svg";
export { ForwardRef as ReactComponent };